/**
 * Captura del canvas WebGL + descarga / Web Share API.
 * No usa @zappar/video-recorder (opcional; verificar licencia/proyecto).
 * Docs snapshot Mattercraft: Take/Share/Download — distinto stack.
 */
export async function captureCanvas(canvas) {
  if (!canvas) throw new Error('Canvas no disponible');
  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('toBlob falló'))), 'image/png');
  });
  const dataUrl = canvas.toDataURL('image/png');
  return { blob, dataUrl };
}

export async function saveOrShareCapture({ blob, dataUrl }, filename = 'ar-challenge.png') {
  const file = new File([blob], filename, { type: 'image/png' });

  if (navigator.share && navigator.canShare?.({ files: [file] })) {
    await navigator.share({
      files: [file],
      title: 'AR Interactive Challenge',
      text: 'Mi resultado en AR Interactive Challenge',
    });
    return { method: 'share' };
  }

  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  return { method: 'download' };
}
